import { styled } from "@mui/material/styles";

/** Flexible spacer that expands to fill available space in a flex container. */
export const Spacer = styled("div")({
  flex: 1,
});
